import { useEffect } from 'react'
import { useAppStore } from './state/useAppStore'
import Topbar from './components/ui/Topbar'
import LeftPanel from './components/ui/LeftPanel'
import MapContainer from './components/map/MapContainer'
import RightPanel from './components/ui/RightPanel'
import Portal from './components/portal/Portal'
import './styles/main.css'

function App() {
  const { isPortalOpen, portalTransitioning } = useAppStore()

  return (
    <div className="relative w-screen h-screen overflow-hidden bg-monster-dark">
      {/* Portal Overlay */}
      {(isPortalOpen || portalTransitioning) && <Portal />}
      
      {/* Main Interface */}
      {!isPortalOpen && !portalTransitioning && (
        <>
          <Topbar />
          <div className="grid grid-cols-12 h-[calc(100vh-64px)] pt-16">
            <div className="col-span-3 p-4">
              <LeftPanel />
            </div>
            <div className="col-span-6 p-4">
              <MapContainer />
            </div>
            <div className="col-span-3 p-4">
              <RightPanel />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default App